import { render } from "./accountinactive.vue?vue&type=template&id=5f7738b0"
import script from "./accountinactive.vue?vue&type=script&lang=js"
export * from "./accountinactive.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__